import React from "react";

function EmailIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="22.5"
      viewBox="0 0 30 22.5"
      {...props}
    >
      <path
        id="email_1_"
        data-name="email (1)"
        d="M27.187,59.882H2.813A2.816,2.816,0,0,0,0,62.695V79.57a2.816,2.816,0,0,0,2.813,2.813H27.187A2.816,2.816,0,0,0,30,79.57V62.695A2.816,2.816,0,0,0,27.187,59.882Zm0,1.875a.932.932,0,0,1,.359.073L15,72.7,2.453,61.83a.933.933,0,0,1,.359-.073Zm0,18.75H2.813a.938.938,0,0,1-.938-.938V63.811L14.386,74.653a.939.939,0,0,0,1.229,0L28.125,63.811V79.57A.938.938,0,0,1,27.187,80.507Z"
        transform="translate(0 -59.882)"
        fill="#2d6289"
      />
    </svg>
  );
}

export default EmailIcon;
